import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login'
import UserModel from '@/models/usercenter'

Vue.use(VueRouter)

const userModel = new UserModel()
const router = new VueRouter({
  mode:'history',
  routes: [
    {
      path: '*',
      redirect:'/l'
    },
    {
      path:'/l',
      name: 'login',
      component: Login
    }
  ]
})

router.beforeEach((to,from,next)=>{
  if(localStorage[UserModel.USER_INFO_KEY]){
    try {
      let userInfo=JSON.parse(localStorage[UserModel.USER_INFO_KEY])
      console.log('本地有登录信息',userInfo)
      userModel.getTokenCode({
        token:userInfo.token
      }).then(res=>{
        console.log('获取登录code:'+res.data,to.query.redirect_uri)
        let defaultUrl = `https://${process.env.VUE_APP_ENV}-bhbl.dayuan1997.com?code=${res.data}`
        if (to.query && to.query.redirect_uri!=="undefined") {
          let realUrl = new URL(decodeURI(this.$route.query.redirect_uri))
          let current = new URL(window.location.href)
          console.log(current.host, realUrl.host)
          if(current.host===realUrl.host){
            window.location.href = defaultUrl
          }else{
            realUrl.searchParams.delete('code')
            realUrl.searchParams.set('code', res.data)
            window.location.href = realUrl.href
          }
        } else {
          window.location.href =defaultUrl
        }
      }).catch(()=>{
        next()
      })
    } catch (error) {
      next()
    }
  }else{
    next()
  }
})

export default router